import * as React from 'react'

import { Box, Checkbox } from '@factorialco/deprecated-design-system'

import SelectField from 'modules/core/components/SelectField'
import i18n from 'modules/core/lib/i18n'

import { useMessageOptions } from 'modules/ats/lib/utils/messages'

interface Props {
  label: string
  value: string
  onChange: (when: string) => void
}

export const DelayMessageSelector = ({ value, onChange }: Props) => {
  const { fallbackOption, defaultOption, sendMessageOptions } = useMessageOptions()
  const [showDelaySelect, setShowDelaySelect] = React.useState(
    sendMessageOptions.some((option) => option.value === value)
  )
  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setShowDelaySelect(!showDelaySelect)
    !event.target.checked && onChange(fallbackOption.value)
  }

  return (
    <Box gap="s12">
      <Checkbox
        checked={showDelaySelect}
        label={i18n.t('ats.smart_actions.sidepanel.delay')}
        size="large"
        onChange={handleOnChange}
      />

      {showDelaySelect && (
        <SelectField
          defaultOption={defaultOption}
          options={sendMessageOptions.map((option) => ({
            label: option.label,
            value: option.value,
          }))}
          onChange={onChange}
          value={value}
        />
      )}
    </Box>
  )
}
